import { CurrencyPipe, formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { BaseService } from 'src/app/_services/base.service';
import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { GlobalService } from 'src/app/_services/global.service';
import { InventoryService } from 'src/app/_services/inventory.service';
import { ReportsService } from 'src/app/_services/reports.service';
import { environment } from 'src/environments/environment';

export interface Sales_Report {
  date: string;
  locationId: string;
  locationName: string;
  totalSaleItems: number;
  totalVoidItems: number;
  discount: number;
  salesTax: number;
  nonTaxableTotals: number;
  taxableTotals: number;
  subTotal: number;
  tipAmount: number;
  grandTotal: number;
  tenderedAmount: number;
  totalInvoices: number;
  shippingAmount: number;
  shippingTax: number;
    netSales: number;
}

@Component({
  selector: 'app-daily-sales-report',
  templateUrl: './daily-sales-report.component.html',
  styleUrls: ['./daily-sales-report.component.scss']
})
export class DailySalesReportComponent implements OnInit, OnDestroy {
  _globals = GlobalService

  shippingAmountTotal = 0
  dataList: Sales_Report[] = [];
  totalInvoices = 0
  totalSaleItems = 0
  totalVoidItems = 0
  subTotal = 0
  discount = 0
  salesTax = 0
  tipTotalAmount = 0
  shippingAmount = 0
  shippingTax = 0
  grandTotal = 0

  colheader = this._abd.reports.filter(x => x.componentName == 'Daily Sales Report')[0].colheader;
  domColHeader = this.colheader[0];
  colflds = this._abd.reports.filter(x => x.componentName == 'Daily Sales Report')[0].colflds;
  summaryHeader = this._abd.reports.filter(x => x.componentName == 'Daily Sales Report')[0].summaryHeader;
  domSummaryHeader = this.summaryHeader[0];
  domSummaryflds = this._abd.reports.filter(x => x.componentName == 'Daily Sales Report')[0].summaryflds;
  // colflds = ['date', 'locationName', 'totalInvoices', 'totalSaleItems', 'totalVoidItems',
  //   'subTotal', 'discount', 'salesTax', 'grandTotal'];

  csvcols = []
  exportColumns: any = ''
  locationIds: string[] = [];

  constructor(private _inventoryService: InventoryService,
    private _bs: BaseService,
    private _reportService: ReportsService,
    private _abd: AppBaseDataService,
    private _spinner: NgxSpinnerService,
    private currencyPipe: CurrencyPipe,
    public _filterService: FilterServiceService,
    private _router: Router,
  ) {
    this.csvcols = this._abd.makeCsvCols(this.colheader, this.colflds)
    this.exportColumns = this.csvcols.map(col => ({ title: col.header, dataKey: col.field }))
  }

  ngOnInit(): void {
    this._router.navigate(['app/daily-sales-report-v2'])
  }

  ngOnDestroy() {
    this._globals.componentName = ''
  }

  getLocationsList() {
    let self = this;
    this.locationIds = [];
    let selLocation = this._filterService.selectedLocation;
    selLocation = (typeof selLocation != 'undefined' && selLocation instanceof Array) ? selLocation : [selLocation];
    selLocation.map(function (value: { locationId: { toString: () => string; }; }) {
      self.locationIds.push(value.locationId.toString())
    })
  }

  getDataList() {
    this.getLocationsList();

    const data = {
      "ReportName": 'SaleReport',
      "Parameter": {
        "StartDate": formatDate(this._filterService.dateRange[0], 'MM/dd/yyyy', 'en-US'),
        "EndDate": formatDate(this._filterService.dateRange[1], 'MM/dd/yyyy', 'en-US'),
        "LocationIds": this.locationIds,
        'OrderPlacement': this._filterService.selectedProductSellTypeFilter?.Value
      }
    }

    const url = this._abd.reports.filter(x => x.componentName == 'Daily Sales Report')[0].reportURL;
    this._abd.showSpinner();
    this._bs.httpPost(url, JSON.stringify(data)).subscribe(res => {
      this.dataList = res.data;
      this.dataList.map((item) => item.netSales = item.subTotal - item.discount )
      this._abd.hideSpinner();
      this.shippingAmountTotal = 0
      this.totalInvoices = 0
      this.totalInvoices = 0
      this.totalSaleItems = 0
      this.totalVoidItems = 0
      this.subTotal = 0
      this.discount = 0
      this.salesTax = 0
      this.shippingAmount = 0
      this.shippingTax = 0
      this.grandTotal = 0
      for (let i = 0; i < this.dataList.length; i++) {
        let obj = this.dataList[i]
        this.shippingAmountTotal += obj.shippingAmount
        this.totalInvoices += obj.totalInvoices
        this.totalSaleItems += obj.totalSaleItems
        this.totalVoidItems += obj.totalVoidItems
        this.subTotal += obj.subTotal

        this.discount += obj.discount
        this.salesTax += obj.salesTax
        this.shippingAmount += obj.shippingAmount
        this.shippingTax += obj.shippingTax
        this.grandTotal += obj.grandTotal
      }
    })
  }

  filterButtonPressed() {
    // alert(this._abd.selectedProductSellTypeFilter.Type)
    this.getDataList()
  }


  callbackFuncFromFilter(event) {

    this.getDataList()
  }

  exportExcel() {
    this.colflds[this.colflds.findIndex(f=> f == "netSale")] = "netSales";
    this._abd.exportExcel(this.dataList, this.summaryHeader[0], this.colflds, 'Daily Sales Report')
  }

  exportPdf() {
    console.log(this.summaryHeader, this.colflds)
    this.colflds[this.colflds.findIndex(f=> f == "netSale")] = "netSales";
    this._abd.exportPdf(this.dataList, this.summaryHeader, this.colflds, 'Daily Sales Report', true)
  }

  calculateSummaryTotal(col: string) {
    let total = "0";
    if (col.includes("Count") || col.includes("Item") || col.includes("item") || col.toLocaleLowerCase().includes("totalinvoices")) {
      total = this.dataList.reduce((sum, item) => sum + item[col], 0).toFixed(0);
    }
    else if (col == 'netSales') {
      total = GlobalService.formatNumberWithCurrencySign(
        this.dataList.reduce((sum, item) => sum + (item['subTotal'] - item['discount']), 0)
      );
    }
    else {
      total = GlobalService.formatNumberWithCurrencySign(
        this.dataList.reduce((sum, item) => sum + item[col], 0)
      );
    }
    return total;

  }

}
